
import { URL } from '../../config'
import { getRequest, postRequest } from '../../utils/httpRequest'
import { 
    FETCH_SCHOOL,SORT_ASCENDING,SORT_DESCENDING, DELETE_SCHOOL,SEARCH_SCHOOLS,RESET_SCHOOLS,
    SAVE_PARTICIPANT_INFO,SAVING_PARTICIPANT_INFO,SAVE_EVENT_CERT_NUMBER ,SEARCHING_SCHOOL,
    SET_SELECTED_SCHOOL,REFRESH_PARTICIPANT_ROSTER,GETTING_PARTICIPANT_ROSTER
} from '.'

const eventURL = URL.event

 export function sortAscending(){
    return {
        type: SORT_ASCENDING
    }
 }
 export function sortDescending(){
    return {
        type: SORT_DESCENDING
    }
 }
 export function searchingSchools(){
    return {
        type: SEARCHING_SCHOOL
    }
 }
export function fetchSchool(schoolName,schoolId,season=2019,schoolType)
{
    const url     = `${URL.season}/teams/${season}/${schoolId}/${schoolName}/${schoolType}`
    const request = getRequest(url)
    return {
        type: FETCH_SCHOOL,
        payload: request
    }
 }
 export function searchSchools(schoolname,season=2019)
 {
    const url = `${URL.season}/schools/${season}/${schoolname}`
    const request = getRequest(url)
    return {
        type: SEARCH_SCHOOLS,
        payload: request
    }
 }
 export function resetSchools() 
 {
    return {
        type: RESET_SCHOOLS,
    }
 }
 export function saveParticipantInfo(participants)
 {
    const url = `${eventURL}/participants`
    const request = postRequest(url,participants)
    return {
         type: SAVE_PARTICIPANT_INFO,
         payload: request
    }
 }
 export function saveEventCertNumber(certdetails)
 {
    const url = `${eventURL}/eventcertnumber`
    const request = postRequest(url,certdetails)
    return {
         type: SAVE_EVENT_CERT_NUMBER,
         payload: request
    }
 }
 export function savingParticipantInfo()
 {
    return {
			type: SAVING_PARTICIPANT_INFO
    }
 }
 export function deleteSchool(schoolIndex) {
    const meta = {
			index:schoolIndex
		}
    return {
			type: DELETE_SCHOOL,
			meta
    }
 }
 export function setSelectedSchool(schoolName)
 {
    return {
        type: SET_SELECTED_SCHOOL,
        payload: schoolName
   }
 }
 export function refreshParticipantRoster(eventId)
 {
    const url = `${eventURL}/updaterosters`
    const request = postRequest(url,{ eventId })
    return {
			type: REFRESH_PARTICIPANT_ROSTER,
			payload: request
    }
 }

 export function gettingParticipantRoster()
 {
    
    return {
         type: GETTING_PARTICIPANT_ROSTER
    }
 }


// WEBPACK FOOTER //
// ./src/redux/actions/action_participants.js